import { BrowserUtils } from "@azure/msal-browser";

/**
 * True when this document is not the top-level window: an iframe (including
 * MSAL's hidden silent-renewal frame) or an MSAL popup.
 *
 * MSAL's redirect and logout APIs are top-frame only. Called from a frame they
 * throw `block_iframe_reload` or `redirect_in_iframe`, so callers use this to
 * avoid attempting interaction that cannot succeed there.
 */
export function isInFrameOrPopup(): boolean {
  return BrowserUtils.isInIframe() || BrowserUtils.isInPopup();
}
